import React from "react";
import { Button } from "reactstrap";
import KEYS from "../../env/env";

// export default function LoginWithGoogle() {
//   // const loginwithgoogle = async () => {
//   //   // let response = await doRequest("", "GET", "auth/google");
//   //   fetch(KEYS.apiPath + "auth/google", {
//   //     method: "GET",
//   //     headers: {
//   //       "Content-Type": "application/json",
//   //     },
//   //   })
//   //     .then((response) => response.json())
//   //     .then(async (val) => {
//   //       if (+val?.resultFlag === 1) {
//   //         // secureLocalStorage.setItem("Login", val?.response?.token);
//   //       }
//   //     })
//   //     .catch((err) => {
//   //       console.log('login with google',err)
//   //     });
//   // };

//   const loginwithgoogle = () => {
//   window.location.href = KEYS.apiPath + "auth/google";
// };

//   return (
//     <div>
//       <Button onClick={loginwithgoogle}>Login with google</Button>
//     </div>
//   );
// }


export const loginwithgoogle = () => {
  window.location.href = KEYS.apiPath + "auth/google";
};


export default function LoginWithGoogle() {
  return (
    <div>
      <Button onClick={loginwithgoogle}>Login with Google</Button>
    </div>
  );
}